export default __webpack_public_path__ + "static/media/mac_4.47b5e61c.jpg";